import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, FileText, TrendingUp, Shield } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="w-8 h-8" data-id="element-163" />,
    title: 'Guía Paso a Paso (PDF)',
    desc: 'El mapa exacto para leer tu reporte y encontrar los errores ocultos.'
  }, {
    icon: <FileText className="w-8 h-8" data-id="element-164" />,
    title: 'El Kit de las 3 Cartas Maestras',
    desc: 'Las plantillas legales en inglés que solo tienes que llenar con tus datos.'
  }, {
    icon: <TrendingUp className="w-8 h-8" data-id="element-165" />,
    title: 'Estrategia de Reconstrucción',
    desc: 'Cómo subir tus primeros 50-100 puntos usando trucos legales como el "Usuario Autorizado".'
  }, {
    icon: <Shield className="w-8 h-8" data-id="element-166" />,
    title: 'Guía de Protección',
    desc: 'Cómo congelar tu crédito para que nadie más pueda dañarlo o robar tu identidad.'
  }];
  return <section className="py-24 bg-white relative" data-id="element-167">
      <div className="container mx-auto px-6" data-id="element-168">
        <FadeIn data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-dark mb-16" data-id="element-170">
            ¿Qué incluye el sistema?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-171">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.15} direction="up" data-id="element-172">
              <div className="flex items-start gap-6 p-8 rounded-2xl bg-brand-cream border border-brand-gold/20 hover:shadow-lg transition-shadow" data-id="element-173">
                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-brand-rose text-white flex items-center justify-center shadow-md" data-id="element-174">
                  {item.icon}
                </div>
                <div data-id="element-175">
                  <h3 className="text-xl font-bold text-brand-dark mb-2" data-id="element-176">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-177">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}